import { ElesPage } from './../eles/eles';
import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';

/**
 * Ele edit page, base class.
 * Derive in class.ts
 * // @TODO Message error
 */
@IonicPage()
@Component({
  selector: 'page-ele',
  templateUrl: 'ele.html',
})
export class ElePage {

  // Parent page, passed by navParams.get('parent')
  parentPage : ElesPage;

  // The Element to edit, can be null in creation, passed by navParams.get('ele')
  ele : any;

  // The Element Id in edit, can be null in creation, passed by navParams.get('eleId')
  eleId : any;

  // Wait for end of execution befor pop, default to false
  waitEndExecutionForPop : boolean = false;



  constructor(public navCtrl: NavController, public navParams: NavParams) {

    this.parentPage = this.navParams.get('parent');
    this.eleId = this.navParams.get('eleId');
    this.ele = Object.assign({}, this.navParams.get('ele') );
  }


  ionViewDidLoad() {
    console.log('ionViewDidLoad ElePage');
  }


  onAddOrUpdateEle() {    

    if (!this.waitEndExecutionForPop) this.navCtrl.pop();
    
    this.parentPage.addOrUpdate(this.eleId, this.ele).then( ()=> { 
      if (this.waitEndExecutionForPop) this.navCtrl.pop();
    }).catch( (error)=> { 
      if (this.waitEndExecutionForPop) this.navCtrl.pop();
      throw error;
    });
  
  } // method onAddOrUpdate


  onDeleteEle() {

    if (!this.waitEndExecutionForPop) this.navCtrl.pop();

    this.parentPage.delete(this.eleId, this.ele).then( ()=> { 
      if (this.waitEndExecutionForPop) this.navCtrl.pop();
    }).catch( (error)=> { 
      if (this.waitEndExecutionForPop) this.navCtrl.pop();
      throw error;
    });

  } // methode onDelete

}




// WEBPACK FOOTER //
// ./src/pages/ele/ele.ts